import axios from "axios";
import Vue from "vue";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedTrainWhereStation: {},
    trainWhereStations: [],
  }),

  mutations: {
    setSelectedTrainWhereStation(state, trainWhereStation) {
      Vue.set(state, "selectedTrainWhereStation", trainWhereStation);
    },
    setTrainWhereStations(state, trainWhereStations) {
      Vue.set(state, "trainWhereStations", trainWhereStations);
    },
    setDefaultTrainWhereStationModule(state) {
      Vue.set(state, "selectedTrainWhereStation", {});
      Vue.set(state, "trainWhereStations", []);
    },
  },

  actions: {
    createTrainWhereStation: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/train-where-stations/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadPublishedTrainWhereStations: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-where-stations/entity/published").then((response) => {
        return response.data;
      });
    },

    loadTrainWhereStation: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-where-stations/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadTrainWhereStations: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-where-stations/entity").then((response) => {
        context.commit("setTrainWhereStations", response.data);
        return response.data;
      });
    },

    loadSelectedTrainWhereStationHistory: (context, trainWhereStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-where-stations/history/" + trainWhereStation.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteTrainWhereStation: (context, trainWhereStation) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/train-where-stations/entity/" + trainWhereStation.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          trainWhereStation.intents = intents;
          trainWhereStation.intentId = response.data.id;
          return trainWhereStation;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftTrainWhereStation: (context, trainWhereStation) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/train-where-stations/draft/" + trainWhereStation.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishTrainWhereStation: (context, trainWhereStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-where-stations/publish/" + trainWhereStation.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectTrainWhereStation: (context, trainWhereStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-where-stations/reject/" + trainWhereStation.intentId).then((response) => {
        helper.recallOrRejectEntity(trainWhereStation, "train_where_station");
        return response.data;
      });
    },
    sendToApprovalTrainWhereStations: (context, trainWhereStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-where-stations/sendToApproval/" + trainWhereStation.intentId).then((response) => {
        if (trainWhereStation.intents[0].type === "CREATE_TRAIN_WHERE_STATION") {
          trainWhereStation.intents[0].status = "WAITING_APPROVAL";
        } else if (trainWhereStation.intents[0].type === "UPDATE_TRAIN_WHERE_STATION") {
          trainWhereStation.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    recallTrainWhereStation: (context, trainWhereStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-where-stations/recall/" + trainWhereStation.intentId).then((response) => {
        helper.recallOrRejectEntity(trainWhereStation, "train_where_station");
        return response.data;
      });
    },
    cancelTrainWhereStation: (context, trainWhereStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-where-stations/cancel/" + trainWhereStation.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedTrainWhereStation: (state) => {
      return state.selectedTrainWhereStation;
    },
    getTrainWhereStations: (state) => {
      return state.trainWhereStations;
    },
    getPublishedTrainWhereStations: (state) => {
      return state.trainWhereStations.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
